<template>
  <div class="app-body">
    <StoreLogTable query-type="seller"
                   :hide-columns="['boxReceiptCode','transferCount','totalReceiveCount','receiverName']" :hide-buttons="['receive','price','back']"
                   :hide-query="['orderCode','boxReceiptCode']"></StoreLogTable>
  </div>
</template>

<script>
/**
 * 发货记录页面
 */
import StoreLogTable from '@/views/modules/erp/common/store-log-table.vue'

export default {
  name: 'erp-send-index',
  components: { StoreLogTable },
  data () {
    return {
      currentTab: 'purchase',
      cacheKey: 'erp:store:send'
    }
  },
  activated () {
    let localCurrentTab = window.localStorage.getItem(this.cacheKey)
    if (localCurrentTab) {
      this.currentTab = localCurrentTab
    }
  },
  watch: {
    currentTab (newVal) {
      window.localStorage.setItem(this.cacheKey, newVal)
    }
  },
  methods: {
    tabChanged (e) {
      console.log('tabChanged', e)
    }
  }
}
</script>

<style scoped>

</style>
